import { MirrorSelect } from '@crasman/multiselect';

/**
 * Initialize multiselect fields
 *
 * @class multiselect
 */
class multiselect {
  constructor() {
    this.multiselect = {};
    window.multiselects = {};
  }

  init(){
    const dropdownElements = document.querySelectorAll('.js-select, .js-multiselect');
    const settings = {
      listElement: { size: 12 },
    };

    dropdownElements.forEach(select => {
      window.multiselects[select.name] = new MirrorSelect(select, settings);
    });
  }
}


export default new multiselect()

